module.exports = __webpack_public_path__ + "img/icon-counter-like.83096fae.svg";